import { render } from "./Loading.vue?vue&type=template&id=b01e4c68"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=b01e4c68&lang=scss"
script.render = render

export default script